import config from "../_config/config";
import { authHeader, postHeader } from "../_helpers";
import axios from "axios";

axios.defaults.baseURL = config.apiUrl;
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.post["X-Requested-With"] = "XMLHttpRequest";
axios.defaults.headers.put["Content-Type"] = "application/json";
axios.defaults.headers.put["X-Requested-With"] = "XMLHttpRequest";

export const adminService = {
  massiveReport,
  appData,
  getServices,
  getPrestazioni,
  enableActivityFor,
  enableSurveyFor,
  enableSurveySessionFor,
  updateActivityStatus,
  updateSurveyStatus,
  getAllFdservices,
  enableFdservice,
  downloadSelectedCompany,
  getActivityLog,
  getAbilitateForActivity,
  getActivityById,
  getFilledSurveysForActivity,
  reportActivityPdf,
  reportActivityXls,
  saveNewCompany,
  assignProjectToCompany,
  getContattiPubblici,
  getExcelContattiPubblici,
  getExcelRegistratiOggi,
  getExcelRegistratiCompleto,
  addNewExam,
  requestUserSubscription,
  getAllExams,
  updateExam,
  deleteExam,
  getRegisteredUsers,
  getRegisteredUserExcel,
  getAvailableSubscriptions,
  generaVoucher,
  getAvailableSubscriptionVouchers,
  deleteVoucher,
  updateVoucher,
  updateVoucherStatus,
  updateService,
  adminUserAnagraficaUpdate,
  deleteUser,
  getReservationByCR,
  getAvailablePrivateSubscriptions,
  assignCustomSubscription,
  setCompanyService,
  updateCompanyServiceStatus,
  getAslForAdmin,
  toggleCompanyStatus,
  updateCompanyAnagrafica,
  removeOperator,
  getCompanyOperators,
  sendCompanyCode,
  toggleOperatorStatus,
  changeOperatorRole,
  sendWelcomeEmailToUser,
  assignOperatorToCompany,
  getAllCompanies,
  searchCompanies,
  importCompanyHealthServices,
  getAllCompanyHealthServices,
  getMetabaseEmbedUrl
};

function massiveReport(data) {
  const sett = { headers: authHeader(), responseType: "blob" };
  return axios
    .post("companies/massive/report", data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function appData(filters) {
  const sett = { headers: authHeader(), params: filters };
  return axios
    .get("utilities/dati/app", sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}
function getServices() {
  const sett = { headers: authHeader() };
  return axios
    .get("services/", sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}
function getPrestazioni() {
  const sett = { headers: authHeader() };
  return axios
    .get("healthservices/", sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function enableActivityFor(data) {
  const sett = { headers: authHeader() };
  var endpoint = "activities/enable/" + data.hash;
  return axios
    .post(endpoint, data.form, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function enableSurveyFor(data) {
  const sett = { headers: authHeader() };
  var endpoint = "activities/surveys/enable/" + data.hash;
  return axios
    .post(endpoint, data.form, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function enableSurveySessionFor(data) {
  const sett = { headers: authHeader() };
  var endpoint = "survey-sessions/enable/" + data.hash;
  return axios
    .post(endpoint, data.form, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function updateActivityStatus(data) {
  const sett = { headers: authHeader() };
  var endpoint = "activities/status/update/" + data.hash;
  return axios
    .put(endpoint, data.form, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function updateSurveyStatus(data) {
  const sett = { headers: authHeader() };
  var endpoint = "activities/surveys/status/update/" + data.hash;
  return axios
    .put(endpoint, data.form, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function getAllFdservices() {
  const sett = { headers: authHeader() };
  return axios
    .get("fdsservices/", sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function enableFdservice(data) {
  const sett = { headers: authHeader() };
  var endpoint = "fdsservices/fdservice/adesioni/set/" + data.hashid;
  return axios
    .post(endpoint, data.form, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}
function downloadSelectedCompany(filters) {
  const sett = { headers: authHeader(), params: filters, responseType: "blob" };
  return axios
    .get("companies", sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function getActivityLog(filters) {
  const sett = { headers: authHeader(), params: filters };
  return axios
    .get("utilities/dati/logs", sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function getAbilitateForActivity(data) {
  const sett = { headers: authHeader(), params: data.filters };
  var endpoint = "activities/abilitate/list/" + data.hash;
  return axios
    .get(endpoint, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function getActivityById(hash) {
  const sett = { headers: authHeader() };
  var endpoint = "activities/" + hash;
  return axios
    .get(endpoint, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function getFilledSurveysForActivity(data) {
  const sett = { headers: authHeader(), params: data.filters };
  var endpoint = "activities/surveys/filled/activity/" + data.hash;
  return axios
    .get(endpoint, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function reportActivityPdf(hash, filters) {
  const sett = { headers: authHeader(), responseType: "blob", params: filters };
  var endpoint = "activities/report/filled/pdf/activity/" + hash;
  return axios
    .get(endpoint, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function reportActivityXls(hash, filters) {
  const sett = { headers: authHeader(), responseType: "blob", params: filters };
  var endpoint = "activities/report/filled/xls/activity/" + hash;
  return axios
    .get(endpoint, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function saveNewCompany(data) {
  const sett = { headers: authHeader() };
  return axios
    .post("companies/new/register", data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function assignProjectToCompany(hash, data) {
  const sett = { headers: authHeader() };
  const endpoint = "companies/" + hash + "/project";
  return axios
    .post(endpoint, data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function getContattiPubblici(filters) {
  const sett = { headers: authHeader(), params: filters };
  return axios
    .get("users/contatti/pubblici", sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function getExcelContattiPubblici() {
  const sett = { headers: authHeader(), responseType: "blob" };
  return axios
    .get("users/contatti/pubblici/export/xls", sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function getExcelRegistratiOggi() {
  const sett = { headers: authHeader(), responseType: "blob" };
  return axios
    .get("users/registrati/oggi/export/xls", sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function getExcelRegistratiCompleto() {
  const sett = { headers: authHeader(), responseType: "blob" };
  return axios
    .get("users/registrati/full/export/xls", sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function addNewExam(data) {
  const sett = { headers: authHeader() };
  return axios
    .post("exams", data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function requestUserSubscription(hash, filters) {
  const sett = { headers: authHeader(), params: filters };
  const endpoint = "users/subscriptions/request/free/" + hash;
  return axios
    .get(endpoint, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function getAllExams(filters) {
  const sett = { headers: authHeader(), params: filters };
  return axios
    .get("exams", sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function updateExam(hashid, data) {
  const sett = { headers: authHeader() };
  var endpoint = "exams/" + hashid;
  return axios
    .put(endpoint, data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function deleteExam(hashid) {
  const sett = { headers: authHeader() };
  var endpoint = "exams/" + hashid;
  return axios
    .delete(endpoint, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function getRegisteredUsers(filters) {
  const sett = { headers: authHeader(), params: filters };
  return axios
    .get("users/registrati", sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function getRegisteredUserExcel(filters) {
  const sett = { headers: authHeader(), responseType: "blob", params: filters };
  return axios
    .get("users/registrati/export/xls", sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function getAvailableSubscriptions() {
  const filters = { client: 2 };
  const sett = { headers: authHeader(), params: filters };
  return axios
    .get("subscriptions", sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function getAvailableSubscriptionVouchers() {
  const sett = { headers: authHeader() };
  return axios
    .get("subscriptions/vauchers/all", sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function generaVoucher(data, hashid) {
  const sett = { headers: authHeader() };
  const endpoint = "subscriptions/" + hashid + "/vaucher";
  return axios
    .post(endpoint, data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function deleteVoucher(hashid) {
  const sett = { headers: authHeader() };
  var endpoint = "subscriptions/vaucher/" + hashid + "/delete";
  return axios
    .delete(endpoint, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function updateVoucher(hashid, data) {
  const sett = { headers: authHeader() };
  var endpoint = "subscriptions/vaucher/" + hashid + "/update";
  return axios
    .put(endpoint, data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function updateVoucherStatus(hashid, data) {
  const sett = { headers: authHeader() };
  var endpoint = "subscriptions/vaucher/" + hashid + "/status";
  return axios
    .patch(endpoint, { enabled: data }, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function updateService(id, data) {
  const sett = { headers: authHeader() };
  return axios
    .put(`services/${id}`, data, sett)
    .then((response) => response.data)
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function adminUserAnagraficaUpdate(hash, data) {
  const sett = { headers: authHeader() };
  const endpoint = "users/anagrafica/" + hash;
  return axios
    .put(endpoint, data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function deleteUser(userHash) {
  const sett = { headers: authHeader() };
  return axios
    .delete("users/profile/" + userHash, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      return Promise.reject(err.response);
    });
}

function getReservationByCR(cr) {
  const sett = { headers: authHeader() };
  return axios
    .get(`reservations/requestcode/${cr}`, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      return Promise.reject(err.response);
    });
}

function getAvailablePrivateSubscriptions() {
  const sett = { headers: authHeader() };
  return axios
    .get("subscriptions/custom/available", sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      return Promise.reject(err.response);
    });
}

function assignCustomSubscription(data, subscriptionId) {
  const sett = { headers: authHeader() };
  return axios
    .post(`subscriptions/custom/${subscriptionId}/assign`, data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      return Promise.reject(err.response);
    });
}

function setCompanyService(companyId, data) {
  const sett = { headers: authHeader() };
  var endpoint = `companies/${companyId}/services/set/${data.service_hash}`;
  const form = data.form;
  return axios
    .patch(endpoint, form, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function updateCompanyServiceStatus(companyId, data) {
  const sett = { headers: authHeader() };
  var endpoint = `companies/${companyId}/services/${data.service_hash}`;
  const form = data.form;
  return axios
    .patch(endpoint, form, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function getAslForAdmin() {
  const sett = { headers: authHeader() };
  return axios
    .get("utilities/aslinfo/admin", sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function toggleCompanyStatus(companyId, data) {
  const sett = { headers: authHeader() };
  const endpoint = `companies/${companyId}/toggle-status`;
  return axios
    .patch(endpoint, data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function updateCompanyAnagrafica(companyId, data) {
  const sett = { headers: authHeader() };
  const endpoint = `companies/${companyId}`;
  return axios
    .put(endpoint, data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function removeOperator(operatorId) {
  const sett = { headers: authHeader() };
  const endpoint = `companies/operators/${operatorId}/remove`;
  return axios
    .delete(endpoint, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function getCompanyOperators(companyId) {
  const sett = { headers: authHeader() };
  const endpoint = `companies/${companyId}/operators`;
  return axios
    .get(endpoint, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function sendCompanyCode(companyId, data) {
  const sett = { headers: authHeader() };
  const endpoint = `companies/${companyId}/admin/code/send`;
  return axios
    .post(endpoint, data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function toggleOperatorStatus(operatorId, data) {
  const sett = { headers: authHeader() };
  // Usa lo stesso endpoint del company service per uniformità
  const endpoint = `users/change/status/${operatorId}`;
  return axios
    .post(endpoint, data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function changeOperatorRole(operatorId, data) {
  const sett = { headers: authHeader() };
  const endpoint = `companies/operators/${operatorId}/admin/change-role`;
  return axios
    .patch(endpoint, data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function sendWelcomeEmailToUser(userHashid) {
  const sett = { headers: authHeader() };
  const endpoint = `users/${userHashid}/send-welcome-email`;
  return axios
    .post(endpoint, {}, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function assignOperatorToCompany(operatorHashid, companyHashid) {
  const sett = { headers: authHeader() };
  const endpoint = `users/${operatorHashid}/assign-to-company`;
  const data = { company_id: companyHashid };
  return axios
    .post(endpoint, data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function getAllCompanies(filters = {}) {
  const sett = { headers: authHeader(), params: filters };
  return axios
    .get("companies/compact/search", sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function searchCompanies(filters = {}) {
  const sett = { headers: authHeader(), params: filters };
  return axios
    .get("companies/compact/search", sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function importCompanyHealthServices(companyId, formData) {
  const sett = { headers: { ...authHeader(), "Content-Type": "multipart/form-data" } };
  const endpoint = `companies/${companyId}/healthservices/import`;
  return axios
    .post(endpoint, formData, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function getAllCompanyHealthServices(companyId) {
  const sett = { headers: authHeader() };
  const endpoint = `healthservices/company/all/${companyId}`;
  return axios
    .get(endpoint, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function getMetabaseEmbedUrl(dashboardId, params = {}) {
  const sett = { headers: authHeader() };
  const data = { dashboardId, params };
  // console.log('Richiesta Metabase:', data);
  return axios
    .post("metabase/embed-url", data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      console.error('Errore Metabase:', err.response?.data || err.message);
      var error = err.response;
      return Promise.reject(error);
    });
}
